import '../../../../icons'

export default {
  name: 'Button',
  props: {
    isPrimary: {
      type: Boolean,
      required: true,
      default: true
    },
    label: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {

  },
  created () {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/component/buttons/button/button.js